export const capitalize = (value) => {
  if (!value) return '';
  const newVal = value.toString();

  if (value === 'ied' || value === 'uas') {
    return newVal.toUpperCase();
  }

  return newVal
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ');
};

export const yesblank = (value) => (value ? 'Yes' : '-');

export const numberornone = (value) => value || 'None';

export const yesno = (value) => (value ? 'Yes' : 'No');
